import { formatDate } from "../services/DateService";

const DateFormat = ({ date, locale }) => {
  const dateFormatted = formatDate(date, locale);

  return <>{dateFormatted}</>;
};

export default DateFormat;
